import * as R from 'ramda'
import React from 'react'
import CommentCard from 'app/components/CommentCard'
const CommentList = ({ comments, CommentCardProps }) => {
  return R.unless(
    R.isNil,
    R.map((item) => {
      return (
        <div key={item.id}>
          <CommentCard item={item} {...CommentCardProps} />
        </div>
      )
    }),
  )(comments)
}

export default React.memo(CommentList)
